import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from '~/utils/navigation';
import { authenticationSelector } from '~/components/authentication/ducks/selectors.js';
import { showNotification } from '~/components/notifications/ducks/notifications.js';
import useLoginFlow from '~/hooks/use-login-flow.js';
import { addLocalRecentlyPlayed } from '../../ducks';
import useGuestLogin from '~/components/guest-login/hooks/use-guest-login';
import { GAME_MODE } from '~/components/casino-shared/constants';

const useGameLauncher = () => {
	const authenticated = useSelector(authenticationSelector);
	const router = useRouter();
	const dispatch = useDispatch();
	const { initializeLogin } = useLoginFlow();
	const { redirectToGuestLogin } = useGuestLogin();

	const gameLauncher = useCallback(
		({
			event,
			mode,
			game,
			depositLogin = false,
			listName,
			listGameIndex,
			selectedSeat = 0 /* temp fix for TS, selected seats starting from 1 normally */
		}) => {
			event?.preventDefault();
			const realMode = mode === GAME_MODE.REAL;
			const handleNotification = () =>
				dispatch(
					showNotification({
						messageKey: 'RESPONSIVE_LOGIN_TO_PLAY',
						color: 'neutral',
						autoHide: true
					})
				);
			const listInfo = { listName, listGameIndex };
			if (depositLogin) {
				redirectToGuestLogin(game.realModeUrl);
				handleNotification();
			} else if (realMode && !authenticated) {
				initializeLogin({
					from: game.realModeUrl
				});
				handleNotification();
			} else if (realMode) {
				// TODO (navigation) - use search params or redux for state
				router.push(game.realModeUrl, { state: { selectedSeat, ...listInfo } });
				dispatch(addLocalRecentlyPlayed(game));
			} else {
				// TODO (navigation) - use search params or redux for state
				router.push(game.funModeUrl, { state: listInfo });
			}
		},
		[authenticated, dispatch, router, initializeLogin, redirectToGuestLogin]
	);
	return { gameLauncher };
};

export default useGameLauncher;
